export default __webpack_public_path__ + "static/media/IMG_2958.PNG.0822a820.png";